'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _booster = require('@ecs/booster');

var _booster2 = _interopRequireDefault(_booster);

var _config = require('./config');

var _utils = require('./utils');

var _request = require('./request');

var _request2 = _interopRequireDefault(_request);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CONFIG = null;

var Bifrost = function () {
  function Bifrost() {
    _classCallCheck(this, Bifrost);
  }

  _createClass(Bifrost, null, [{
    key: 'initialize',
    value: function initialize(config) {
      CONFIG = (0, _config.setConfig)(config);
    }
  }, {
    key: 'getConfig',
    value: function getConfig() {
      return _extends({}, CONFIG);
    }
  }, {
    key: 'getValgrindAI',
    value: function getValgrindAI() {
      return (0, _utils.getCookie)(CONFIG.cookie.key.ai);
    }
  }, {
    key: 'setValgrindAI',
    value: function setValgrindAI() {
      (0, _utils.setCookie)(CONFIG.cookie.key.ai, Boolean(true).toString(), 1, CONFIG.cookie.domain);
    }
  }, {
    key: 'setValgrind',
    value: function setValgrind(session) {
      (0, _utils.setCookie)(CONFIG.cookie.key.ai, Boolean(true).toString(), 1, CONFIG.cookie.domain);
      (0, _utils.setCookie)(CONFIG.cookie.key.au, session.token, 1, CONFIG.cookie.domain);

      _booster2.default.emit('BOOSTER_USER', session);
    }
  }, {
    key: 'deleteValgrind',
    value: function deleteValgrind() {
      (0, _utils.deleteCookie)(CONFIG.cookie.key.ai, CONFIG.cookie.domain);
      (0, _utils.deleteCookie)(CONFIG.cookie.key.au, CONFIG.cookie.domain);
    }
  }, {
    key: 'getCpfValgrind',
    value: function getCpfValgrind() {
      return (0, _utils.getSessionStorage)('valgrind-userCpf');
    }
  }, {
    key: 'setCpfValgrind',
    value: function setCpfValgrind(cpf) {
      (0, _utils.setSessionStorage)('valgrind-userCpf', cpf);
    }
  }, {
    key: 'session',
    value: function session(callback) {
      var ok = function ok(response) {
        _booster2.default.emit('BOOSTER_USER', response);

        callback(null, response);
      };

      var authenticated = Bifrost.getValgrindAI();

      if (CONFIG.cookie.check && authenticated !== 'true') {
        callback(true, { status: 1 });
        return;
      }

      (0, _request2.default)('/session', null, function (err, req) {
        if (err) {
          if (req.status === 401 || req.status === 419) {
            Bifrost.deleteValgrind();
          }

          _booster2.default.emit('BOOSTER_GA', {
            category: 'exception',
            action: 'sessao',
            label: req.status
          });

          callback(err, req);
        } else {
          ok(req.response);
        }
      });
    }
  }, {
    key: 'sessionify',
    value: function sessionify() {
      return new Promise(function (resolve, reject) {
        Bifrost.session(function (err, req) {
          if (err) {
            reject(req);
            return;
          }

          resolve(req);
        });
      });
    }
  }, {
    key: 'logout',
    value: function logout(token, callback) {
      Bifrost.deleteValgrind();

      (0, _request2.default)('/user/logout', { token: token }, function (error, response) {
        callback(error, response);
      });
    }
  }]);

  return Bifrost;
}();

exports.default = Bifrost;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ecs/bifrost/build/index.js
// module id = 32
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30 31 32 33 34 35 36 37 38